export enum WebsocketEventType {
  courseProgressUpdated = 'COURSE_PROGRESS_UPDATED',
  authenticate = 'AUTHENTICATE',
}

export enum LocalEventType {
  adobeImsReady = 'ADOBE_IMS_READY',
  courseProgressUpdated = 'COURSE_PROGRESS_UPDATED',
}

export enum MetadataType {
  languages = 'languages',
  countries = 'countries',
  academicLevels = 'academicLevels',
  badges = 'badges',
  credlyBadges = 'credlyBadges',
  certifications = 'certifications',
  regions = 'regions',
  contentStandards = 'contentStandards',
  subjects = 'subjects',
  copyLicenses = 'copyLicenses',
  schoolTypes = 'schoolTypes',
  fileTypes = 'fileTypes',
  jobFunctions = 'jobFunctions',
  educationSegments = 'educationSegments',
  reputationLevels = 'reputationLevels',
  teachingExperiences = 'teachingExperiences',
  technicalExpertise = 'technicalExpertise',
  topics = 'topics',
  resourceTypes = 'resourceTypes',
  forums = 'forums',
  products = 'products',
  courseType = 'courseType',
}

export enum BrowseResourceType {
  courses = 'courses',
  resources = 'resources',
  discussions = 'discussions',
}

export enum EntityStatus {
  active = 'active',
  inactive = 'inactive',
  deleted = 'deleted',
  archived = 'archived',
}

export enum CourseDifficulty {
  beginner = 'beginner',
  intermediate = 'intermediate',
  advanced = 'advanced',
}

export enum CourseType {
  instructorLed = 'instructor-led',
  selfPaced = 'self-paced',
  toolkit = 'toolkit',
  nonSearchableInstructorLed = 'live-instructor-led',
}
